import { jwtDecode } from "jwt-decode";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../localStorage/localStorage";

type JwtPayload = {
  exp: number;
  userId?: string;
  parentId?: string;
  mtId?: string;
};

export function clearJwtToken() {
  removeLocalStorage("jwtToken");
}

export function setJwtToken(jwtToken: string) {
  return setLocalStorage("jwtToken", jwtToken);
}

export function getJwtToken() {
  return getLocalStorage("jwtToken");
}

export function getJwtAuthToken() {
  return getJwtToken() ? `Bearer ${getJwtToken()}` : "";
}

export function getDecodedJwtToken() {
  try {
    return jwtDecode<JwtPayload>(getJwtToken()!);
  } catch {
    return undefined;
  }
}

function getJwtTokenProperty<JwtProperty extends keyof JwtPayload>(
  property: JwtProperty
) {
  return getDecodedJwtToken()?.[property];
}

export function getJwtTokenExpiry() {
  return getJwtTokenProperty("exp") ?? 0;
}

export function getJwtTokenUserId() {
  return getJwtTokenProperty("userId");
}

export function getJwtTokenParentId() {
  return getJwtTokenProperty("parentId");
}

export function getJwtTokenMtId() {
  return getJwtTokenProperty("mtId");
}

export function isValidSession() {
  return getJwtTokenExpiry() * 1000 > Date.now();
}

export const fetchUser = () => {
  const ids = {
    userId: getJwtTokenUserId(),
    parentId: getJwtTokenParentId(),
    mtId: getJwtTokenMtId(),
  };

  return {
    loggedIn: !!(ids.userId || ids.mtId),
    ...ids,
  };
};

export type WebappUser = ReturnType<typeof fetchUser>;
